import React, { useEffect } from 'react'
import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SBack,
  SLowcodeList,
  STableActions,
  SMessage,
  SDrawerOrModal,
  SAlert, SAside, STags,
} from 'shj-components'
import { Form, message, Upload, Switch, Button } from 'antd'
import { useSetState } from "ahooks";
import {
  importCombinationProductInfo,
  getCombinationProductList,
  deleteCombinationProductInfo,
  batchDeleteCombinationProductInfo,
  getCombinationSkuList,
  exportCombinationProductInfo,
  getBrandList,
  getProdCateTree,
  getProductEnums,
  productCombinationDetailBatchUpdateDate,
  getSpecialCodesListNew,
} from '@/services/product'
import { fileDownload } from '@/utils/download.ts'
import { DownloadOutlined, UploadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import UrlConfig from '@/api/UrlConfigs.ts'
import { config } from './config/index.tsx'
import styles from './index.module.less'
import AddSubProductModal from "@/pages/combinationManage/components/AddSubProductModal";
import { useSearchParams } from "react-router-dom";
import CopyModal from "@/pages/combinationManage/components/CopyModal";
import EditTimeModal from "@/pages/combinationManage/components/EditTimeModal";
import LogsModal from "@/pages/combinationManage/components/LogsModal";
import EditModal from "@/pages/combinationManage/components/EditModal";
import ChooseSKUModal from "@/pages/combinationManage/components/ChooseSKUModal";
import SKUDetailModal from "@/pages/combinationManage/components/SKUDetailModal";

export default function QuoteContract() {
  const [search] = useSearchParams()
  const mainProductId = search.get('mainId')
  const listRef = useRef()
  const skuListRef = useRef()
  const [importLoading, setImportLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)
  const [exportDataLoading, setExportDataLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [selectId, setSelectId] = useState('')
  const [treeData, setTreeData] = useState<any>([])
  const [prodCateIds, setProdCateIds] = useState([])
  const [chooseDiabled, setChooseDisabled] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [dataList, setDataList] = useState([])
  const [state, setState] = useSetState<any>({
    editType: 'start',
    record: {},
  })

  useEffect(() => {
    listRef.current?.reload()
  }, [prodCateIds]);

  const fetchList = async values => {
    try {
      if (!prodCateIds || prodCateIds[0] == '0') {
        values.query.prodCateIds = []
      } else {
        values.query.prodCateIds = prodCateIds
      }
      if (values.query.currentDate) {
        values.query.currentDate = values.query.currentDate.format('YYYY-MM-DD')
      }
      const res: any = await getCombinationProductList({
        data: {
          ...values.query,
          queryApplyProductShop: true,
          orderBys: [
            {
              columnName: "MAIN_PRODUCT_ID",
              asc: false
            },
            {
              columnName: "CREATED_TIME",
              asc: false
            }
          ]
        },
        params: {
          pageId: values?.current,
          pageSize: values?.pageSize,
        },
      })
      if (!res?.list) {
        message.error('查询列表失败')
        return
      }
      const data = res?.list?.reduce((acc, item) => {
        // 为每个项目添加背景色标识
        if (acc.length === 0) {
          // 第一个项目，设置为第一种背景色
          acc.push({ ...item, _bgType: 'group1' });
        } else {
          const lastItem = acc[acc.length - 1];
          // 如果当前项目的mainProductId与上一个相同，则使用相同的背景色
          if (lastItem.mainProductId === item.mainProductId) {
            acc.push({ ...item, _bgType: lastItem._bgType });
          } else {
            // 如果不同，则切换背景色
            const newBgType = lastItem._bgType === 'group1' ? 'group2' : 'group1';
            acc.push({ ...item, _bgType: newBgType });
          }
        }
        return acc;
      }, []);
      setDataList(data)
      setTotalCount(res?.count)
      return {
        records: data,
        total: res?.count,
      }
    } catch (err) {
      message.error('查询列表失败')
    }
  }

  const fetchSkuList = async values => {
    console.log(values)
    try {
      const res: any = await getCombinationSkuList(selectId, {
        data: {
          ...values,
          skuNameKeyword: values?.query?.skuNameKeyword,
          id: values?.query?.id,
        },
        params: {
          pageId: values?.current,
          pageSize: values?.pageSize,
        },
      })
      if (!res?.list) {
        message.error('查询列表失败')
        return
      }
      return {
        records: res?.list,
        total: res?.count,
      }
    } catch (err) {
      message.error('查询列表失败')
    }
  }

  const onDelete = async (record: any = {}) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteCombinationProductInfo(record.id)
          if (res.errorCode === 0) {
            message.success('删除成功')
            ;(listRef as any)?.current?.reload()
          } else {
            message.error('删除失败')
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除')
      },
    })
  }

  const onImport = async (upload: any) => {
    setImportLoading(true)
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    try {
      const res: any = await importCombinationProductInfo(data)
      listRef.current && listRef.current.reload()
      onSuccess && onSuccess()
      if (res?.length) {
        let str = ''
        res.forEach((item, index) => {
          if (item?.errorMessages?.length) {
            str =
              str +
              ' ' +
              `第${item.lineNumber}行` +
              '、' +
              item?.errorMessages.join('、')?.slice(0, 100)
          }
        })
        str = str?.slice(0, 300)
        if (str !== '') {
          message.error(str)
        } else {
          message.success(res.message || '导入成功')
        }
      } else {
        message.success(res.message || '导入成功')
      }
      setImportLoading(false)
    } catch (err) {
      setImportLoading(false)
      console.log(err)
    }
  }

  const onExport = async () => {
    try {
      setExportLoading(true)
      await fileDownload(UrlConfig.PlusProductWeb.DownloadCombinationProductInfo)
      setExportLoading(false)
    } catch (err) {
      setExportLoading(false)
      console.log(err)
    }
  }

  const onExportData = async () => {
    const searchValue = listRef?.current?.getSearch()?.getFieldsValue()
    try {
      setExportDataLoading(true)
      await fileDownload(UrlConfig.PlusProductWeb.ExportCombinationProductInfo, {
        method: 'POST',
        ...searchValue,
        prodCateIds,
        currentDate: searchValue.currentDate?.format('YYYY-MM-DD'),
        queryApplyProductShop: true,
        orderBys: [
          { columnName: "MAIN_PRODUCT_ID", asc: false },
          { columnName: "CREATED_TIME", asc: false },
        ]
      })
      setExportDataLoading(false)
    } catch (err) {
      setExportDataLoading(false)
      console.log(err)
    }
  }

  const onMultipleDelete = ({ selectedRowKeys }) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await batchDeleteCombinationProductInfo(selectedRowKeys)
          if (res.errorCode === 0) {
            message.success('删除成功')
            ;(listRef as any)?.current?.reload()
          } else {
            message.error('删除失败')
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除')
      },
    })
  }
  //   右侧下拉选项加载
  const getOptions = async () => {
    const categoryTree: any = await getProdCateTree({
      productLibrary: 'RETAIL_LIBRARY'
    })
    const specialCodeList: any = await getSpecialCodesListNew({
      data: {},
    })
    const sourceTypeList = await getProductEnums('com.shj.saas.plus.product.enums.ProductSourceType')
    setTreeData([{ cateName: '不限', id: '0' }, ...categoryTree])
    return Promise.resolve({
      categoryTree,
      sourceTypeList,
      enabledList: [{ label: '启用', value: true }, { label: '禁用', value: false }],
      specialCodeList: specialCodeList.map(item => ({ label: item.showName, value: item.code }))
    })
  }

  const onChangeType = (node: any, info) => {
    console.log(info)
    setProdCateIds([])
    if (info.selected) {
      setProdCateIds(prevIds => [...prevIds, info.node.id])
      findAllChildsId(info.node)
    }
  }
  const findAllChildsId = (node: any) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => {
        setProdCateIds(prevIds => [...prevIds, child.id])
        findAllChildsId(child)
      })
    }
  }

  const onDetail = record => {
    setState({SKU_DETAIL: true, record})
  }

  const skuConfig = {
    rowSelection: false,
    columns: [
      {
        title: 'SKU_ID',
        key: 'id',
        dataIndex: 'id',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: 'SKU名称',
        key: 'skuName',
        dataIndex: 'skuName',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: '规格',
        key: 'argName',
        dataIndex: 'argName',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: '单位',
        key: ['unitInfo', 'unitName'],
        dataIndex: ['unitInfo', 'unitName'],
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
    ],
    search: [
      {
        name: 'id',
        label: 'SKU_ID',
      },
      {
        name: 'skuNameKeyword',
        label: 'SKU名称',
      },
    ],
  }

  const onEditTimeOrSort = (record) => {
    setState({ EDIT: true, record })
  }

  const onCopy = (record) => {
    setState({ COPY: true, record })
  }

  const onLogs = (record) => {
    setState({ LOGS: true, record })
  }

  const onBatchChangeStartTime = ({ selectedRowKeys }) => {
    onCheckDate(selectedRowKeys, 'start')
  }
  const onBatchChangeEndTime = ({ selectedRowKeys }) => {
    onCheckDate(selectedRowKeys, 'end')
  }

  const onCheckDate = (keys, editType = 'start') => {
    const query = listRef.current?.getSearch()?.getFieldsValue()
    if(prodCateIds?.length > 0 && prodCateIds[0] !== '0' ){
      query.prodCateIds = prodCateIds
    }
    if (editType === 'start') {
      productCombinationDetailBatchUpdateDate({
        ids: chooseDiabled ? undefined : keys,
        query: chooseDiabled ? query : undefined,
        onlyCheck: true,
      }).then(() => {
        setState({ EDIT_DATE: true, editType })
      })
    } else {
      setState({ EDIT_DATE: true, editType })
    }
  }

  const onBatchAddSubProduct = () => {
    setState({ ADD_SUB_PRODUCT: true })
  }

  const onCloseModal = (key) => {
    setState({ [key]: false })
  }

  const allSelect = () => {
    if (chooseDiabled) {
      setChooseDisabled(false)
      listRef?.current?.clearSelectedRowKeys()
    } else {
      setChooseDisabled(true)
      const ids: any = dataList?.map((item: any) => item.id)
      setSelectedRowKeys(ids)
    }
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: {
      onMultipleDelete,
      onBatchChangeStartTime,
      onBatchChangeEndTime,
      onBatchAddSubProduct,
      allSelect,
    },
    rowKey: 'id',
    rowClassName: (record) => {
      return record._bgType === 'group1' ? styles.group1 : styles.group2;
    },
    getCheckboxProps: record => ({
      disabled: chooseDiabled,
    }),
    selectedRowKeys: selectedRowKeys,
    onSelectedRowChange: (keys, rows) => {
      setSelectedRowKeys(keys)
    },
    status: {
      selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
      // exportLoading: state.exportLoading,
      delBtnDisabled: () => chooseDiabled,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onDetail(record)}>SKU详情</SActionBtn>
            <SActionBtn onClick={() => onEditTimeOrSort(record)}>编辑</SActionBtn>
            <SActionBtn onClick={() => onCopy(record)}>复制</SActionBtn>
            <SActionBtn onClick={() => onLogs(record)}>调整记录</SActionBtn>
            <SActionBtn danger onClick={() => onDelete(record)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      enabledRender(v) {
        return <STags
          itemKey=""
          label={v ? '启用' : '禁用'}
          fontColor={v ? '#00A865' : '#EB3723'}
          bgColor={v ? '#D7F7EA' : '#FFEAE8'}
        />
      },
      shopNameRender(v) {
        const names = v?.map?.(item => item.companyName)
        return names?.join?.(', ')
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={importLoading}
              disabled={importLoading}
              icon={<UploadOutlined/>}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            icon={<DownloadOutlined/>}
            onClick={onExport}
            disabled={exportLoading}
            loading={exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
      exportRenderData: () => {
        return (
          <Button
            icon={<DownloadOutlined/>}
            onClick={onExportData}
            disabled={exportDataLoading}
            loading={exportDataLoading}
            type="dashed"
          >
            导出
          </Button>
        )
      },
    },
  }

  // 右侧表格配置
  const skuExtensions = {
    request: { fetchList: fetchSkuList },
  }

  const onReloadList = () => {
    listRef.current?.reload?.()
    setChooseDisabled(false);
    setSelectedRowKeys([]);
    listRef?.current?.clearSelectedRowKeys()
  }

  const getQuery = () => {
    const query = listRef.current?.getSearch?.()?.getFieldsValue?.() || {}
    if(prodCateIds?.length > 0 && prodCateIds[0] !== '0'){
      query.prodCateIds = prodCateIds
    }
    return query
  }

  return (
    <div className={styles.settlementQuotaConfig}>
      <div className={styles.leftMenu}>
        {/* 左侧树形选择 */}
        <SAside
          treeData={treeData}
          onSelect={onChangeType}
          title={''}
          treeType="tree"
          defaultSelectedKeys={['0']}
          // active={state.categoryCode}
          fieldNames={{ title: 'cateName', key: 'id' }}
          header={false}
          dropItems={false}
        />
      </div>
      {/* 右侧数据表格 */}
      <div className={styles.rightTable}>
        {/*<SAlert type="info">
          在SPU新增组合产品后，可在该位置进行组合明细的导入。主产品指组合产品，子产品指组合产品中的单品。
        </SAlert>*/}
        <SLowcodeList ref={listRef} searchMode="group"
                      config={{
                        ...config,
                        searchInitialValues:
                          {
                            mainProductKeyword: mainProductId || undefined,
                          }
                      }}
                      rowSelectedTotal={chooseDiabled ? totalCount : ''}
                      {...extensions} />
      </div>
      {state['SKU_DETAIL'] && <SKUDetailModal
          open={state['SKU_DETAIL']}
          record={state.record}
          onClose={() => onCloseModal('SKU_DETAIL')}
      />}
      <AddSubProductModal
        query={chooseDiabled ? { query: getQuery() } : { mainProductIds: listRef.current?.getSelectedRows()?.[1]?.map(item => item.mainProductId) }}
        open={state['ADD_SUB_PRODUCT']}
        onClose={() => onCloseModal('ADD_SUB_PRODUCT')}
        onReload={onReloadList}
      />
      {state['COPY'] && <CopyModal
          record={state.record}
          open={state['COPY']}
          onReload={listRef.current?.reload}
          onClose={() => onCloseModal('COPY')}
      />}
      {state['EDIT_DATE'] && <EditTimeModal
        open={state['EDIT_DATE']}
        editType={state.editType}
        record={state.record}
        query={chooseDiabled ? { query: getQuery() } : { ids: selectedRowKeys }}
        onReload={onReloadList}
        onClose={() => onCloseModal('EDIT_DATE')}
      />}
      {state['LOGS'] && <LogsModal
        open={state['LOGS']}
        record={state.record}
        onClose={() => onCloseModal('LOGS')}
      />}
      {
        state['EDIT'] && <EditModal
          open={state['EDIT']}
          record={state.record}
          onReload={listRef.current?.reload}
          onClose={() => onCloseModal('EDIT')}
        />
      }
    </div>
  )
}
